module.exports = __webpack_public_path__ + "static/media/join-in-img1-1.b91a18bf.jpg";